import { forEach } from 'lodash';
import uri from 'urijs';
import { getConfig } from './config';

export default (externalUrl, sectionUrl) => {
  const sectionUri = uri(sectionUrl || getConfig().sectionUrl || '');
  const sectionUrlWithoutQuery = uri(sectionUrl || getConfig().sectionUrl || '').search('').toString();
  const externalUri = uri(externalUrl.replace(sectionUrlWithoutQuery, ''));

  const sectionParams = sectionUri.search(true);
  const externalParams = externalUri.search(true);

  forEach(sectionParams, (value, key) => {
    if (externalParams[key] === value) {
      delete externalParams[key];
    }
  });

  return externalUri.search(externalParams).toString();
};



// WEBPACK FOOTER //
// ./app/services/get-inner-url.js